import React from 'react';
import { pureRender } from 'epic-alt-utils';
import { NavActions } from '../../actions';
import autobind from 'core-decorators/lib/autobind';

@pureRender
export default class LocaleIcon extends React.Component {

    @autobind
    showLocale() {
        if (!this.props.isActive) {
            NavActions.mobileLocaleActive(true);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.mobileLocaleActive(false);
            if (this.context.isMobile) {
                NavActions.mobileNavActiveLinks(true);
            }
        }

        //Reset all other clickable items
        NavActions.egNavActive(false);
        NavActions.tabletNavActive(false);
        NavActions.mobileActiveLinkIndex(null);
        NavActions.searchActive(false);
        NavActions.mobileUserActive(false);
    }

    render() {
        const localeOnClick = this.context.isMobile ? this.showLocale : null;

        return (
            <a data-locale={this.props.currentLocale} title={this.props.currentLocale} onClick={localeOnClick} className="locale-icon text-color-hover">
                {!this.context.isMobile || (this.context.isMobile && !this.props.isActive) ? <i className="eg-header-icon-locale"></i> : ''}
            </a>
        );
    }

}

LocaleIcon.propTypes = {
    isActive: React.PropTypes.bool,
    currentLocale: React.PropTypes.string
};

LocaleIcon.contextTypes = {
    messages: React.PropTypes.object,
    isMobile: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/locale/LocaleIcon.js
 **/